<template>
  <v-list-item
    dense
    class="py-0"
    :class="{ 'grey lighten-4': coltura.coltura.esaurito }"
    style="min-height: 40px"
  >
    <v-list-item-avatar
      size="18"
      class="my-0 mr-2"
      :style="{ opacity: coltura.coltura.esaurito ? 0.5 : 1 }"
    >
      <v-img v-if="fornitore_logo" :src="fornitore_logo" />
      <v-icon v-else small color="grey lighten-1">mdi-domain</v-icon>
    </v-list-item-avatar>
    <v-list-item-content
      class="py-1"
      :style="{ opacity: coltura.coltura.esaurito ? 0.6 : 1 }"
    >
      <v-list-item-subtitle class="text-caption">
        <template v-if="fornitore_nome">{{ fornitore_nome }} · </template
        >Lotto {{ lotto ? lotto.codice : "…" }}
        <v-tooltip v-if="coltura.coltura.esaurito" top>
          <template v-slot:activator="{ on, attrs }">
            <v-chip x-small outlined color="red" class="ml-1" v-bind="attrs" v-on="on">
              {{ testo_esaurito }}
            </v-chip>
          </template>
          <span v-if="data_esaurito">esaurito il {{ data_esaurito }}</span>
          <span v-else>data di esaurimento non disponibile</span>
        </v-tooltip>
      </v-list-item-subtitle>
      <v-list-item-subtitle class="text-caption grey--text">
        Trapianto {{ data_trapianto }} · Pos. {{ data_posizionamento }}
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="flex-row align-center my-0" style="gap: 2px">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="grey darken-1"
            v-bind="attrs"
            v-on="on"
            @click="$refs.storia.open(coltura.lotto, coltura.coltura)"
          >
            <v-icon>mdi-history</v-icon>
          </v-btn>
        </template>
        <span>Storia completa</span>
      </v-tooltip>
      <StoriaLottoDialog ref="storia" />
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            :color="coltura.coltura.esaurito ? 'red' : 'green'"
            v-bind="attrs"
            v-on="on"
            @click="modifica_stato()"
            ><v-icon>{{
              coltura.coltura.esaurito ? "mdi-cancel" : "mdi-check-circle-outline"
            }}</v-icon></v-btn
          >
        </template>
        <span>{{ coltura.coltura.esaurito ? "Segna come disponibile" : "Segna come esaurito" }}</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            small
            color="blue"
            v-bind="attrs"
            v-on="on"
            @click="$refs.picker.open()"
            ><v-icon>mdi-swap-horizontal</v-icon></v-btn
          >
        </template>
        <span>Sposta in un'altra serra</span>
      </v-tooltip>
      <SerraPickerDialog
        ref="picker"
        :value="coltura.coltura.serra_attuale"
        require_selection
        @conferma="sposta"
      />
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import moment from "moment";
import SerraPickerDialog from "./SerraPickerDialog.vue";
import StoriaLottoDialog from "@/components/Lotti/desktop/storia_lotto_dialog.vue";

export default {
  name: "SerraColturaElement",
  components: { SerraPickerDialog, StoriaLottoDialog },
  props: {
    // { coltura: ColturaLotto.to_json(), lotto: id_lotto }, come restituito
    // da GET /admin/lotti/serra/:id_serra/colture. Riga di dettaglio di UN
    // lotto: il raggruppamento per prodotto (avatar + nome) è a carico del
    // genitore (SerraProdottoGruppoElement).
    coltura: Object,
  },
  computed: {
    lotto() {
      let lotto = this.$store.getters.get_lotto_by_id(this.coltura.lotto);
      if (lotto) {
        return lotto;
      }
      this.$store.dispatch("get_lotto_by_id", this.coltura.lotto);
      return null;
    },
    fornitore() {
      if (!this.lotto) return null;
      return this.$store.getters.get_fornitore_by_id(this.lotto.id_fornitore);
    },
    fornitore_nome() {
      return this.fornitore ? this.fornitore.nome : null;
    },
    fornitore_logo() {
      if (!this.fornitore) return null;
      return (
        process.env.VUE_APP_API_ROOT +
        "/fornitore/" +
        this.fornitore.id +
        "/avatar?t=" +
        this.fornitore.logo_md5
      );
    },
    data_posizionamento() {
      return moment.unix(this.coltura.coltura.ts_posizionamento).format("DD MMMM YYYY");
    },
    data_trapianto() {
      return moment.unix(this.coltura.coltura.ts_trapianto).format("DD MMMM YYYY");
    },
    data_esaurito() {
      if (!this.coltura.coltura.ts_esaurito) return null;
      return moment.unix(this.coltura.coltura.ts_esaurito).format("DD MMMM YYYY");
    },
    testo_esaurito() {
      if (!this.coltura.coltura.ts_esaurito) return "esaurito";
      return "esaurito " + moment.unix(this.coltura.coltura.ts_esaurito).fromNow();
    },
  },
  methods: {
    modifica_stato() {
      this.$store
        .dispatch("cambia_stato_produzione_coltura", {
          id_lotto: this.coltura.lotto,
          id_coltura: this.coltura.coltura.id,
          esaurito: !this.coltura.coltura.esaurito,
        })
        .then(() => {
          this.$emit("cambia_stato");
        });
    },
    sposta(nuove_serre) {
      // Difesa in profondità: il picker con require_selection blocca già la
      // conferma a vuoto, ma senza questo controllo uno spostamento a
      // selezione vuota azzererebbe serra_attuale orfanizzando la coltura.
      if (!nuove_serre || !nuove_serre.length) {
        return;
      }
      this.$store
        .dispatch("sposta_lotto_zona_coltura", {
          id_lotto: this.coltura.lotto,
          id_coltura: this.coltura.coltura.id,
          serre_destinazione: nuove_serre,
          ts_posizionamento: moment().format("X"),
        })
        .then(() => {
          this.$emit("cambia_stato");
        });
    },
  },
};
</script>
